import RadioButton from 'components/formComponents/Base/RadioButton';
import { UnionRole } from '../../../../../types/PartyApplication/partyApplication';
import { UnionSectionTexts } from '../../../../../types/PartyApplication/PartyApplicationTexts';

type Props = {
  texts?: UnionSectionTexts;
};

const UnionRoleSelect = ({ texts }: Props) => {
  return (
    <>
      <RadioButton
        header={texts?.unionHeadline || 'Facklig roll'}
        name="unionRole"
        options={[
          {
            id: String('union-role-' + UnionRole.UnionRepresentative),
            value: UnionRole.UnionRepresentative,
            displayValue:
              texts?.unionRepresentative?.label ??
              'Ombudsman (anställd på fackförbundet)',
            sortOrder: texts?.unionRepresentative?.radioSortOrder ?? 1,
          },
          {
            id: String('union-role-' + UnionRole.UnionLocalRepresentative),
            value: UnionRole.UnionLocalRepresentative,
            displayValue:
              texts?.unionLocalRepresentative?.label ??
              'Förtroendevald (anställd på företaget)',
            sortOrder: texts?.unionLocalRepresentative?.radioSortOrder ?? 2,
          },
        ]}
      />
    </>
  );
};

export default UnionRoleSelect;
